import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { PersonDto, ValidationError } from 'src/app/api/models';
import { DcUserService } from 'src/app/api/services';
import { ErrorMsgHelper } from '../../helpers/errormsg.helper';
import { ToastrMsgService } from '../../services/toastr-msg.service';
import { CustomTranslationService } from '../../translation/custom-translation.service';
import { untilComponentDestroyed } from '../../helpers/rxjs.operator';
import { OldNewPasswordValidator } from '../../validators/old-new-password.validator';

@Component({
    selector: 'diana-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {

  form!: FormGroup;
  passwordHide1: boolean = true;
  passwordHide2: boolean = true;
  passwordHide3: boolean = true;
  user?: PersonDto;
  error?: string;
  @ViewChild('intOldPassword') _intOldPassword!: ElementRef;


  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: Observable<PersonDto>,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private userService: DcUserService,
    private toastrMsg: ToastrMsgService,
    private translateSrv: CustomTranslationService
  ) { }

  get oldPassword() {
    return this.form.get('currentPassword');
  }

  get newPassword() {
    return this.form.get('newPassword');
  }

  get repeatPassword() {
    return this.form.get('repeatPassword');
  }

  ngOnInit(): void {
    this.data.subscribe(user => {
      this.user = user;
    });
    this.form = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      repeatPassword: ['', [Validators.required]],
    }, {
      validators: OldNewPasswordValidator('currentPassword', 'newPassword', 'repeatPassword')
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSave() {
    const user = this.user;
    if (user && user.dcUserId) {
      this.userService.changePassword({
        id: user.dcUserId,
        body: {
          newValues: {
            pwd: btoa(this.newPassword?.value)
          },
          oldValues: {
            pwd: btoa(this.oldPassword?.value)
          }
        }
      }).pipe(untilComponentDestroyed(this))
      .subscribe(r => {
        this.onNoClick();
        this.error = undefined;
        this.toastrMsg.showSuccess('password.change.success.toast');
      }, (error) => {
        const serverError = ErrorMsgHelper.parseError(error);
        if (serverError.length > 0) {
          const sError = serverError[0] as ValidationError;
          if (sError.message) {
            this.error = ErrorMsgHelper.defineErrorMsg(this.translateSrv, sError);
          }
          if (sError.errorCode === ErrorMsgHelper.USER_WRONG_PASSWORD) {
            if (this._intOldPassword) {
              this._intOldPassword.nativeElement.focus();
            }
          }
        }
      });
    }
  }
}
